import React from 'react';
import ReactDOM from 'react-dom';
import {AppShell} from 'app/components/AppShell';
import {Admin} from 'app/components/admin/Admin';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme();

const App = () => {
  let pathname;
  if (typeof window !== 'undefined') {
    pathname = window.location.pathname;
  }

  return <ThemeProvider theme={theme}>{pathname === '/admin' ? <Admin /> : <AppShell />}</ThemeProvider>;
};

ReactDOM.hydrate(<App />, document.getElementById('root'));
